import React from 'react';

import Box from '@mui/material/Box';

import { UserRoleProvider } from 'context/user-role';

import { PrivateLayout } from 'components/Layouts';
import GlobalScrollStyles from 'components/shared/CustomScroll/GlobalScrollStyles';

import { useDevice } from 'hooks';

import PrivateRoutes from 'routes';

import { mainContainerMobileStyles, mainContainerStyles } from '../styles';

const PrivateApp = () => {
  const { isMobile } = useDevice();

  return (
    <UserRoleProvider runProcessInit>
      <Box
        sx={{
          ...mainContainerStyles,
          ...(isMobile ? mainContainerMobileStyles : {}),
        }}
      >
        <PrivateLayout>
          <GlobalScrollStyles baseColor="#6D46DD" sizePx={8} />
          <PrivateRoutes />
        </PrivateLayout>
      </Box>
    </UserRoleProvider>
  );
};

export default PrivateApp;
